/**
 * 供应商索赔常量定义
 */
import { SupplierClaimStatus, SupplierClaimType } from './enums';

/**
 * 索赔类型选项
 */
export const SUPPLIER_CLAIM_TYPE_OPTIONS = [
  { value: SupplierClaimType.QUALITY, label: '质量问题', color: 'error' },
  { value: SupplierClaimType.SHORTAGE, label: '数量短缺', color: 'warning' },
  { value: SupplierClaimType.DELAY, label: '交期延误', color: 'warning' },
  { value: SupplierClaimType.PACKAGE, label: '包装破损', color: 'default' },
  { value: SupplierClaimType.OTHER, label: '其他', color: 'default' },
] as const;

/**
 * 索赔类型文本映射
 */
export const SUPPLIER_CLAIM_TYPE_TEXT_MAP: Record<SupplierClaimType, string> = {
  [SupplierClaimType.QUALITY]: '质量问题',
  [SupplierClaimType.SHORTAGE]: '数量短缺',
  [SupplierClaimType.DELAY]: '交期延误',
  [SupplierClaimType.PACKAGE]: '包装破损',
  [SupplierClaimType.OTHER]: '其他',
};

/**
 * 索赔状态选项
 */
export const SUPPLIER_CLAIM_STATUS_OPTIONS = [
  { value: SupplierClaimStatus.PENDING, label: '待处理', color: 'default' },
  { value: SupplierClaimStatus.CONFIRMED, label: '已确认', color: 'processing' },
  { value: SupplierClaimStatus.PAID, label: '已赔付', color: 'success' },
  { value: SupplierClaimStatus.CLOSED, label: '已关闭', color: 'default' },
  { value: SupplierClaimStatus.REJECTED, label: '已驳回', color: 'error' },
] as const;

/**
 * 索赔状态文本映射
 */
export const SUPPLIER_CLAIM_STATUS_TEXT_MAP: Record<SupplierClaimStatus, string> = {
  [SupplierClaimStatus.PENDING]: '待处理',
  [SupplierClaimStatus.CONFIRMED]: '已确认',
  [SupplierClaimStatus.PAID]: '已赔付',
  [SupplierClaimStatus.CLOSED]: '已关闭',
  [SupplierClaimStatus.REJECTED]: '已驳回',
};

/**
 * 索赔状态颜色映射
 */
export const SUPPLIER_CLAIM_STATUS_COLOR_MAP: Record<SupplierClaimStatus, string> = {
  [SupplierClaimStatus.PENDING]: 'default',
  [SupplierClaimStatus.CONFIRMED]: 'processing',
  [SupplierClaimStatus.PAID]: 'success',
  [SupplierClaimStatus.CLOSED]: 'default',
  [SupplierClaimStatus.REJECTED]: 'error',
};
